import $ from 'jquery'

export default {
    name: 'assure-bilan-sante',
    components: {},
    props: {
        list_exclu_bilan_santes: Array
    },
    data() {
        return {
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_BILAN_SANTE', this.one_is_checked)
        }
    },

    computed: {
        liste_bilan_sante(){
            return this.$store.getters["liste_bilan_sante"];
        },
    },

    mounted() {
        this.listeBilanSante()
    },

    methods: {
        listeBilanSante() {
            this.$store.dispatch('getListeBilanSante').then(() => {
                if (this.liste_bilan_sante.length > 0) {
                    this.setSelectedBilanSante()
                } 
            })
        },

        setSelectedBilanSante() {
			this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_bilan_santes.forEach(exclusion => {
                this.liste_bilan_sante.forEach(bilan => {
					if (exclusion.id == bilan.id) {
                        this.text_grey[bilan.id] = 'text-grey'
                        this.one_is_checked.push(bilan.id)
                    } 
                });
            });
		},

        toutSelectionner() {
            let is_checked = $('#all-bilan').is(":checked")
            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.liste_bilan_sante.forEach((bilan) => {
                if (is_checked) {
                    this.one_is_checked.push(bilan.id)
                }
                this.text_grey[bilan.id] = (is_checked)?'text-grey':''
            });
            
            this.all_checked = is_checked
        },

        onExclu(index) {
            let is_checked = $('#bilan'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
        },
    }
}